import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35cb88d6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=35cb88d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb88d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\huixin\\云商\\V12_saas版\\erp-flexible-web21-cloud-saas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35cb88d6')) {
      api.createRecord('35cb88d6', component.options)
    } else {
      api.reload('35cb88d6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35cb88d6&scoped=true", function () {
      api.rerender('35cb88d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mailZone/index.vue"
export default component.exports